export enum MetricsTabKey {
  PerformanceMetrics = 'performanceMetrics',
  SizeOfAccount = 'sizeOfAccount',
  TextAds = 'textAds',
  PerformanceTracker = 'performanceTracker',
}
